import { useLayoutEffect, useState } from 'react'

const EDGE_TOLERANCE = 1

type ScrollEdges = {
  hasContentAbove: boolean
  hasContentBelow: boolean
}

const NO_OVERFLOW: ScrollEdges = {
  hasContentAbove: false,
  hasContentBelow: false,
}

export const useScrollEdges = (element: HTMLElement | null) => {
  const [edges, setEdges] = useState<ScrollEdges>(NO_OVERFLOW)

  useLayoutEffect(() => {
    if (!element) return

    const measure = () => {
      const { scrollTop, scrollHeight, clientHeight } = element
      const hasContentAbove = scrollTop > EDGE_TOLERANCE
      const hasContentBelow =
        scrollTop + clientHeight < scrollHeight - EDGE_TOLERANCE
      setEdges((current) =>
        current.hasContentAbove === hasContentAbove &&
        current.hasContentBelow === hasContentBelow
          ? current
          : { hasContentAbove, hasContentBelow }
      )
    }

    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    Array.from(element.children).forEach((child) => observer.observe(child))
    element.addEventListener('scroll', measure, { passive: true })

    return () => {
      observer.disconnect()
      element.removeEventListener('scroll', measure)
    }
  }, [element])

  return edges
}
